exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#img-perspective-component {\n  position: absolute;\n  z-index: 50;\n  opacity: 0;\n}\n#img-perspective-component #img-computer {\n  position: fixed;\n  z-index: 1;\n  width: 100vw;\n  height: 100vh;\n  top: 0;\n  left: 0;\n}\n#img-perspective-component .tilt {\n  left: -73%;\n  top: -61%;\n  width: 100vw;\n  height: 100vh;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/davidlagace/Sites/david-lagace-website/src/app/components/img-perspective/img-perspective.component.less
// module id = ../../../../../src/app/components/img-perspective/img-perspective.component.less
// module chunks = main